import React from 'react'

import { AuthContext } from '../../main/ProvedorAutenticacao'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import imagemRelatorio from '../../pages/seguranca/img/ilaw-logo.png'

import GraficosService from '../../app/service/GraficoPessoasService'

class Aniversariantes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      aniversariantes: [],
      openSpinner: false,
    }

    this.graficoService = new GraficosService();
  }

  consultar = async (empresa,mes,idade) => {
    const filtro = {
      empresa: empresa,
      mes: mes,
      idade: idade
    }
    await this.graficoService.aniversariantes(filtro)
      .then(response => {
        this.setState({aniversariantes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Aniversariantes', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    const params = this.props.match.params;
    this.setState({openSpinner: true});
    await this.consultar(params.empresa,params.mes,params.idade);
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <br></br>
        <div style={{margin: '38px'}}>
            <div>
              <img src={imagemRelatorio} width="200" height="140"/>
            </div>
            <span className="relatorio">Aniversariantes</span>
            <br></br>
            <br></br>
            <br></br>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <DataTable value={this.state.aniversariantes}  alwaysShowPaginator responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                              paginatorRight selectionMode="multiple">
                    <Column field="nome" header="Nome"></Column>
                    <Column field="dataNascimento" header="Data Nascimento"></Column>
                    <Column field="email" header="E-mail"></Column>
                    <Column field="idade" header="Idade"></Column>
                  </DataTable>
                </div>
              </div>
            </div>
        </div>
      </>
    );
  }
}

Aniversariantes.contextType = AuthContext;
export default withRouter(Aniversariantes)